// extracted by mini-css-extract-plugin
module.exports = {"CatalogList":"CatalogList_CatalogList__j_BMO","CatalogList_item":"CatalogList_CatalogList_item__2GHPw","CatalogList_item___empty":"CatalogList_CatalogList_item___empty__elP2N"};